
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.143 7.42h15.713v10a1.428 1.428 0 01-1.428 1.428H3.57a1.429 1.429 0 01-1.428-1.428v-10 0zM19.285 5.991V3.134c0-.789-.64-1.429-1.428-1.429H2.143c-.79 0-1.429.64-1.429 1.429V5.99c0 .789.64 1.428 1.429 1.428h15.714c.789 0 1.428-.64 1.428-1.428zM7.857 11.705h4.285","stroke":"#339299","stroke-width":"1.429","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    